var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrow2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 71,
    viewBox: "0 0 64 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2879_7161)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.181 20.8384C9.32716 21.5547 17.4519 23.4721 25.2276 26.4761C33.0033 29.48 40.354 33.5083 47.1428 38.4844C50.9667 41.2849 54.5398 44.4123 57.9458 47.7395C58.1196 47.9106 58.4794 48.2316 58.7344 48.1104C58.9895 47.9892 58.7434 47.6155 58.6134 47.4837C52.5305 41.2683 45.4364 35.982 37.9688 31.7374C30.5206 27.5038 22.5811 24.2672 14.4193 22.2012C9.82151 21.0314 5.16195 20.2402 0.49113 19.8327C0.187372 19.8054 0.305925 20.175 0.407161 20.3316C0.572586 20.5881 0.88434 20.8101 1.181 20.8384Z",
    fill: "#344157"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.1416 42.9836C58.0476 44.1758 58.9255 45.3883 59.763 46.6258C60.1669 47.2239 60.5636 47.823 60.9502 48.4295C61.2824 48.9498 61.7205 49.4982 61.9211 50.0842C62.1217 50.6702 61.8599 50.9925 61.2732 50.9019C60.6048 50.795 59.9326 50.6074 59.2694 50.4592C57.8632 50.1493 56.4608 49.8284 55.052 49.558C54.786 49.5075 54.6627 49.6549 54.7693 49.9162C54.8827 50.1977 55.223 50.4701 55.5073 50.5407C57.0712 50.9289 58.6491 51.2612 60.2232 51.6044C61.1089 51.7968 63.3946 52.6251 63.1368 50.9071C63.045 50.2886 62.658 49.7409 62.3309 49.2169C61.8893 48.5124 61.4354 47.8125 60.9733 47.1228C60.0337 45.7167 59.0462 44.3412 58.0196 42.9979C57.8461 42.768 57.5312 42.4606 57.2262 42.4801C56.9399 42.4986 56.9993 42.8023 57.141 42.9882L57.1416 42.9836Z",
    fill: "#344157"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2879_7161"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 62.4655,
    height: 33.5205,
    fill: "white",
    transform: "translate(27.3574 0.398438) rotate(54.2168)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow2);
export default __webpack_public_path__ + "static/media/arrow2.1e8aacce.svg";
export { ForwardRef as ReactComponent };